export const arr1 = [
  { text: 'Задание: найди карту точек (звездочек), похожую на твою. И, если всё получится, ты узнаешь название и автора этой мелодии.', buttonTitle: 'Начать' },
]

export const arr2 = [
  { text: 'Поздравляю, ты нашел её!' },
  { text: 'Это «Имперский марш (Тема Дарта Вейдера)», из к/ф “Звездные войны”, написана Джоном Уильямсом.', buttonTitle: 'Продолжить' },
]

export const hint = [
  { text: 'Смотри внимательнее.' },
]
